// extracted by mini-css-extract-plugin
module.exports = {"main":"CustomParamsData_main__1oy5T"};